import { semanticThemeTokens, Sheet } from "@appretio/ui-kit";
import { Outlet, type RouteObject } from "react-router-dom";
import { PurchaseReviewPage } from "./pages/purchaseReview/PurchaseReviewPage";

const ROOT = "assortment" as const;

const PATH = {
  PURCHASE_REVIEW: "purchase-review",
  CATEGORY: "category",
  COLOUR: "colour",
  EFFICIENCY: "efficiency",
  PRICE: "price"
} as const;

const LABEL = {
  ROOT: "Assortment",
  PURCHASE_REVIEW: "Purchase Review",
  CATEGORY: "Category",
  COLOUR: "Colour",
  EFFICIENCY: "Efficiency",
  PRICE: "Price"
} as const;

const BG = semanticThemeTokens.backgroundGradient[3];

export const assortmentRoutes: RouteObject = {
  path: ROOT,
  handle: { label: LABEL.ROOT, background: BG },
  element: <Outlet />,
  children: [
    {
      path: PATH.PURCHASE_REVIEW,
      handle: { label: LABEL.PURCHASE_REVIEW, background: BG },
      element: <PurchaseReviewPage />,
      children: [
        {
          index: true,
          handle: { label: LABEL.PURCHASE_REVIEW },
          element: <Sheet>{LABEL.PURCHASE_REVIEW} page</Sheet>
        },
        {
          path: PATH.CATEGORY,
          handle: { label: LABEL.CATEGORY },
          element: <Sheet>{LABEL.CATEGORY} page</Sheet>
        },
        {
          path: PATH.COLOUR,
          handle: { label: LABEL.COLOUR },
          element: <Sheet>{LABEL.COLOUR} page</Sheet>
        },
        {
          path: PATH.EFFICIENCY,
          handle: { label: LABEL.EFFICIENCY },
          element: <Sheet>{LABEL.EFFICIENCY} page</Sheet>
        },
        {
          path: PATH.PRICE,
          handle: { label: LABEL.PRICE },
          element: <Sheet>{LABEL.PRICE} page</Sheet>
        }
      ]
    }
  ]
};
